<div>
  <ul 
    class="w-full flex gap-4 list-none"
    [ngClass]="{'flex-col': !isFormMode}"
  >
    <li 
      *ngFor="let option of optionConfig; index as i" 
      class="flex"
      [ngClass]="{'w-[50%]': isFormMode}"
    >
      <button
        type="button"
        tabindex="0"
        class="w-full flex bg-[#ffffff] border-none outline outline-1 rounded-lg items-center focus:outline-none focus:ring-2 focus:ring-blue-500"
        [ngClass]="{
          'outline-[#e8e8e8]': option.id !== selectedOptionId, 
          'outline-[#333333]': option.id === selectedOptionId,
          'py-4': isFormMode, 
          'h-[100px]': !isFormMode
        }"
        (click)="emitSelectedOption(option.optionMetadata)"
      >
        <img
          *ngIf="option.icon"
          [src]="option.icon"
          [alt]="option.iconAltText"
          class="size-6 mx-4 self-center"
        />
        <div class="flex justify-between grow" [ngClass]="{'ml-4': !option.icon}">
          <div class="flex flex-col font-['Roboto'] font-medium items-start text-[#333333] text-base">
            <p>{{ option.title }}</p>
            <p>{{ option.subtitle }}</p>
          </div>
          <img
            *ngIf="option.id === selectedOptionId"
            src="assets/images/payment-method-icons/payment-method-check-icon.svg"
            alt="selected option checkmark icon"
            class="size-6 mr-4 self-center"
          />
        </div>
      </button>
    </li>
  </ul>
</div>
